/// <amd-module name="Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefresh/TestHubRefreshModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { TestHubRefreshReducer } from "./TestHubRefreshReducer";
import { ITestHubRefreshAwareState } from "./TestHubRefreshContracts";

/**
 * Redux dynamic module for the 'global' test hub refresh state.
 */
export const TestHubRefreshModule: ISagaModule<ITestHubRefreshAwareState> = {
    id: "suites",
    reducerMap: {
        testHubRefreshState: TestHubRefreshReducer
    }
};
